import React from "react";
import { useI18n } from "../contexts/I18nContext";

export function SectionHeader({ eyebrow, title, description, id }) {
  return (
    <div className="mb-10" data-testid={id}>
      {eyebrow && <div className="text-xs uppercase tracking-widest text-[var(--js-secondary)] font-semibold mb-2">{eyebrow}</div>}
      <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-[var(--js-text)]">{title}</h2>
      {description && <p className="mt-3 text-[var(--js-muted)] max-w-2xl">{description}</p>}
    </div>
  );
}

export function Chip({ children, variant = "default" }) {
  const cls = variant === "free" ? "js-chip js-chip-free" : variant === "paid" ? "js-chip js-chip-paid" : "js-chip";
  return <span className={cls}>{children}</span>;
}

export function Empty({ title = "Nothing here yet", hint }) {
  return (
    <div className="js-card p-10 text-center" data-testid="empty-state">
      <div className="font-heading text-xl text-[var(--js-primary)] mb-2">{title}</div>
      {hint && <p className="text-sm text-[var(--js-muted)]">{hint}</p>}
    </div>
  );
}

export function PageHero({ title, subtitle, badge }) {
  const { t } = useI18n();
  return (
    <section className="section" style={{ background: "linear-gradient(180deg,#F9F6F0 0%, #F1EADD 100%)" }}>
      <div className="container-narrow">
        {badge && <div className="text-xs uppercase tracking-widest text-[var(--js-secondary)] font-semibold mb-3">{badge}</div>}
        <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl text-[var(--js-primary)]">{title}</h1>
        {subtitle && <p className="mt-4 text-lg text-[var(--js-muted)] max-w-3xl">{subtitle}</p>}
      </div>
    </section>
  );
}
